import { SearchShop } from '@remodeling/shop';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Box, HStack, Icongraphy, Text } from '@design-system/pc';

const OverlayBox = ({
  item,
  currentHover,
  ...props
}: {
  item: SearchShop;
  currentHover: number;
}) => {
  const isHover = currentHover === item.id;
  const isFlagship = item.type.flagshipYn === 'Y';

  const [isOpen, setIsOpen] = useState(true);

  useEffect(() => {
    if (!isFlagship) return;
    const timer = setTimeout(() => {
      setIsOpen(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, [isFlagship]);

  if (isHover) {
    return (
      <MarkerContainer {...props}>
        <HStack
          display="flex"
          alignItems="center"
          backgroundColor="color_chip.white"
          border="1.5px solid"
          borderColor="color_chip.primary"
          borderRadius="100px"
          gap={4}
          height={48}
          padding="3px 12px 3px 0px"
        >
          <HStack
            borderRadius="50%"
            backgroundColor="color_chip.blue.500"
            width={36}
            height={36}
            display="flex"
            alignItems="center"
            justifyContent="center"
            marginLeft={1}
          >
            <Icongraphy
              variant="ic_store_solid"
              resize
              size={28}
              style={{ transform: 'translate(1px, 0px)' }}
              useFillColor
              fillColor="white"
            />
          </HStack>
          {isFlagship ? (
            <HStack>
              <Icongraphy variant="ic_sparkle_solid" resize size={20} />
              <Text variant="label_lg_b" color="color_chip.primary">
                {item.name}
              </Text>
            </HStack>
          ) : (
            <Text variant="label_lg_b" color="color_chip.primary">
              {item.name}
            </Text>
          )}
          <ArrowIcon />
        </HStack>
      </MarkerContainer>
    );
  }

  if (isFlagship) {
    return (
      <MarkerContainer {...props}>
        <AnimatedWrapper data-open={isOpen} $isOpen={isOpen}>
          <HStack
            display="flex"
            alignItems="center"
            justifyContent="center"
            borderRadius="50%"
            width={44}
            height={44}
            backgroundColor="color_chip.white"
          >
            <HStack
              borderRadius="50%"
              borderColor="color_chip.gray.500"
              backgroundColor="#555555"
              width={38}
              height={38}
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Icongraphy
                variant="ic_store_solid"
                resize
                size={28}
                style={{ transform: 'translate(1px, 0px)' }}
                fillColor="white"
              />
            </HStack>
          </HStack>

          <IconOnMarker data-open={isOpen}>
            <Icongraphy variant="ic_sparkle_solid" resize size={14} />
          </IconOnMarker>

          {isOpen && (
            <HStack gap={2} justifyContent="center" marginLeft="-1.5px">
              <Icongraphy variant="ic_sparkle_solid" resize size={20} />
              <Text variant="label_lg_b">플래그십</Text>
            </HStack>
          )}
        </AnimatedWrapper>
      </MarkerContainer>
    );
  }

  return (
    <MarkerContainer {...props}>
      <HStack
        display="flex"
        alignItems="center"
        justifyContent="center"
        borderRadius="50%"
        width={44}
        height={44}
        backgroundColor="color_chip.white"
        border="1px solid"
        borderColor="color_chip.gray.200"
      >
        <HStack
          borderRadius="50%"
          borderColor="color_chip.gray.500"
          backgroundColor="#555555"
          width={38}
          height={38}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <Icongraphy
            variant="ic_store_solid"
            resize
            size={28}
            style={{ transform: 'translate(1px, 0px)' }}
            fillColor="white"
          />
        </HStack>
      </HStack>
    </MarkerContainer>
  );
};

export default OverlayBox;

const MarkerContainer = styled(Box)`
  cursor: pointer;
`;

const AnimatedWrapper = styled(Box)<{ $isOpen: boolean }>`
  display: flex;
  align-items: center;
  padding-left: 0.5px;
  background-color: ${(props) => props.theme.colors.color_chip.white};
  border: 1.5px solid;
  border-radius: 100px;
  gap: 4px;
  height: 48px;
  width: ${({ $isOpen }) => ($isOpen ? '142px' : '48px')};
  transition: width 0.4s ease, border-color 0.3s ease 1s,
    background-color 0.3s ease 1s;

  &[data-open='false'] {
    border-color: transparent;
    background-color: transparent;
  }
`;
const ArrowIcon = styled(Box)`
  height: 18px;
  width: 12px;
  position: absolute;
  bottom: -18px;
  left: 35px;
  border-top: 8px solid ${(props) => props.theme.colors.color_chip.primary};
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
`;

const IconOnMarker = styled(Box)`
  display: flex;
  position: absolute;
  top: 2px;
  left: 30px;
  width: 16px;
  height: 16px;
  border: 0.5px solid rgba(0, 0, 0, 0.2);
  background-color: ${(props) => props.theme.colors.color_chip.white};
  border-radius: 100%;
  justify-content: center;
  align-items: center;

  opacity: 0;
  transition: opacity 0.3s ease 1s;

  [data-open='false'] & {
    opacity: 1;
    transform: translateY(0);
  }
  svg {
    position: relative;
    left: 0px;
  }
`;
